export default {
  payWelfareText: 'Zalety doładowania',
  blackFridayDiscount: 'Zniżka czasowa z okazji Black Friday',
  shareGift: 'Podziel się prezentem',
  vipWeeklyWelfare: 'Tygodniowa zniżka VIP',
  exchangeCoupon: 'Kupon',
  firstPayOff: 'Do 15% zniżki na pierwszy zakup',
  blackFridayEvent: 'Wydarzenie Black Friday',
  limitedTimeOff: 'Ograniczona czasowo zniżka 10%',
  claimCoupon: 'Odbierz teraz',
  blackFridayTimedCoupon: 'Kupon czasowy Black Friday',
  timeLeft: 'Pozostały czas: ',
  claimTimeCoupon: 'Odbierz kupon 10% zniżki już teraz!',
  points: 'Punkty: ${point}',
  costPointTip: 'Wymieniaj punkty na kupony',
  maxPointTip: 'Każde konto może wykorzystać do 500 punktów.',
  discountOff: '10% zniżki',
  highestDiscount: 'Do ${discount} zniżki',
  needPoint: 'Wymaga ${point} pkt',
  changeCurrency: 'Zmień walutę',
  claim: 'Odbierz',
  claimSucc: 'Odebrano',
  claimFail: 'Porażka',
  pointNotEnough: 'Za mało punktów',
  afterClaimPoint: 'Pozostałe punkty: ${point}',
  footTips1: 'Do każdego zamówienia można wykorzystać tylko 1 kupon.',
  footTips2: 'Kuponu nie można wykorzystać do zakupu walut/tokenów w grze.',
  footTips3:
    ' Zastrzegamy sobie prawo do ostatecznej interpretacji tego wydarzenia.',
  ruleTitleText: 'Zasady wydarzenia',
  ruleTime:
    'Czas trwania wydarzenia: 00:00 24 listopada 2023 r. do 23:59 26 listopada 2023 r. (UTC)',
  bfRuleText1:
    '1. 400 punktów zostanie przyznanych na konto użytkownika po pierwszym zalogowaniu się na oficjalnej stronie doładowania podczas wydarzenia. Można wymienić do 500 punktów na kupony.',
  bfRuleText2:
    '2. Punkty Black Friday można wymieniać na kupony podczas wydarzenia.',
  bfRuleText3:
    '3. Do każdego zamówienia można użyć tylko 1 kuponu. Kuponów nie można wykorzystać do zakupu walut/tokenów w grze.',
  bfRuleText4: '4. W przypadku transakcji akceptujemy tylko następujące waluty:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Nie można zmienić waluty po dokonaniu transakcji. Wymienione punkty nie podlegają zwrotowi.',
  bfRuleText6: '6. Kupony Black Friday są ważne tylko przez 7 dni.',
  bfRuleText7:
    '7. Zastrzegamy sobie prawo do ostatecznej interpretacji tego wydarzenia.',
  thanksTip:
    'Dziękujemy za udział. Dołącz do naszej oficjalnej społeczności, aby uzyskać więcej informacji o wydarzeniu.',
  exchangePoints: 'Wymień',
  exchangeCode: 'Wpisz kod wymiany.',
  enterExchangeCode: 'Wpisz kod wymiany.',
  exchangeText: 'Wymień',
  confirmGet: 'Potwierdź',
  couponUsedWay:
    'Kupon można wykorzystać tylko w określonych walutach, prosimy o potwierdzenie waluty.',
  confirmText: 'Potwierdź',
  exchangeSucc: 'Wymieniono',
  aboutCoins: 'Informacje o walutach/tokenach w grze',
  aboutCoinsText:
    'Waluty/tokeny w grze można wymieniać na wszystkie pakiety i przywileje z wyjątkiem samej waluty/tokena w grze.',
  known: 'OK',
  codeText: 'Kod',
  codeInvalid: 'Nieprawidłowy kod!',
  hasExchanged: 'Nie można ubiegać się o więcej kodów.',
  hideText: 'Ukryj',
  //黑五的报错码
  'bf-20001': 'Niezalogowany',
  'bf-20002': 'Błąd parametru. Spróbuj ponownie wziąć udział w wydarzeniu.',
  'bf-20003': 'Za mało punktów',
  'bf-20004':
    'Nie udało się! Spróbuj ponownie później lub skontaktuj się z działem obsługi klienta.',
  'bf-20005': 'Odebrano',
  'bf-20015': 'Wydarzenie jest obecnie niedostępne.',
  'bf-20016': 'Wydarzenie się zakończyło.',
  bfShareText: 'Odbierz kupon 10% zniżki już teraz!',
  rightsCenterBtn: 'Centrum członków premium',
  payBtn: 'Płatność',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorious Extraordinaire (Permanent)',
  '-': '-'
};
